import { useState } from 'react';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import { Loader2, Send } from 'lucide-react';

export const ContactForm = () => {
    const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.email || !form.subject || !form.message) {
            toast.error('Tous les champs marqués sont obligatoires');
            return;
        }
        setLoading(true);
        try {
            await api.post('/contact', form);
            toast.success('Message envoyé. Nous vous répondrons rapidement.');
            setForm({ name: '', email: '', phone: '', subject: '', message: '' });
        } catch {
            toast.error('Erreur lors de l\'envoi. Réessayez.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <form data-testid="contact-form" onSubmit={submit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className="text-xs uppercase tracking-[0.2em] text-[#A3A39D]">Nom *</label>
                    <input
                        data-testid="contact-name-input"
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                        className="w-full bg-transparent border-b border-[#222] focus:border-[#C5A059] py-3 mt-2 text-[#F8F8F5] outline-none"
                    />
                </div>
                <div>
                    <label className="text-xs uppercase tracking-[0.2em] text-[#A3A39D]">Email *</label>
                    <input
                        data-testid="contact-email-input"
                        type="email"
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        className="w-full bg-transparent border-b border-[#222] focus:border-[#C5A059] py-3 mt-2 text-[#F8F8F5] outline-none"
                    />
                </div>
                <div>
                    <label className="text-xs uppercase tracking-[0.2em] text-[#A3A39D]">Téléphone</label>
                    <input
                        data-testid="contact-phone-input"
                        value={form.phone}
                        onChange={(e) => setForm({ ...form, phone: e.target.value })}
                        className="w-full bg-transparent border-b border-[#222] focus:border-[#C5A059] py-3 mt-2 text-[#F8F8F5] outline-none"
                    />
                </div>
                <div>
                    <label className="text-xs uppercase tracking-[0.2em] text-[#A3A39D]">Sujet *</label>
                    <input
                        data-testid="contact-subject-input"
                        value={form.subject}
                        onChange={(e) => setForm({ ...form, subject: e.target.value })}
                        className="w-full bg-transparent border-b border-[#222] focus:border-[#C5A059] py-3 mt-2 text-[#F8F8F5] outline-none"
                    />
                </div>
            </div>
            <div>
                <label className="text-xs uppercase tracking-[0.2em] text-[#A3A39D]">Message *</label>
                <textarea
                    data-testid="contact-message-input"
                    rows={5}
                    value={form.message}
                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                    className="w-full bg-transparent border-b border-[#222] focus:border-[#C5A059] py-3 mt-2 text-[#F8F8F5] outline-none resize-none"
                />
            </div>
            <button
                data-testid="contact-submit-btn"
                type="submit"
                disabled={loading}
                className="bg-[#C5A059] text-black px-10 py-4 uppercase tracking-[0.25em] text-xs font-medium hover:bg-[#DCC283] transition-colors flex items-center gap-3"
            >
                {loading ? <Loader2 className="animate-spin" size={16} /> : <Send size={14} />}
                Envoyer
            </button>
        </form>
    );
};
